import React from "react";
import { Route, Routes } from "react-router-dom";
import "../src/assets/style/color.scss";
import "../src/assets/style/custome.scss";
import "../src/assets/style/fonts.scss";
import "../src/assets/style/height.scss";
import "../src/assets/style/responsive.scss";
import "../src/assets/style/style.scss";
import "../src/assets/style/width.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import "@progress/kendo-theme-default/dist/all.css";
import "react-datepicker/dist/react-datepicker.css";
import UserList from "./screens/AdminList/AdminList";
import Layout from "./components/Layouts/Layout";
import Login from "./screens/Login/Login";
import Registration from "./screens/Login/Registration";
import Role from "./screens/Role/Role";
import AddRole from "./screens/Role/AddRole";
import UsersList from "./screens/UserList/UsersList";
import DeviceList from "./screens/DeviceList/DeviceList";
import DeviceAdd from "./screens/DeviceList/DeviceAdd";
import LocationMarks from "./screens/Locations/LocationMarks";
import ResetPassword from "./screens/Login/ResetPassword";
import MembersList from "./screens/UserList/MembersList";
import Report from "./screens/Report/Report";
import NotificationReport from "./screens/Report/NotificationReport";
import AppLogout from "./components/Layouts/AppLogout";
import Logfile from "./screens/Log/Logfile";
import Company from "./screens/Company/Company";
import CompanyRole from "./screens/CompanyRole/CompanyRole";
import CompanyRoleAdd from "./screens/CompanyRole/CompanyRoleAdd";
import LayoutCompany from "./components/Layouts/LayoutCompany";
import Manager from "./screens/CompanyScreens/Manager/Manager";
import CompanyRoles from "./screens/CompanyScreens/CompanyRoles/CompanyRoles";
import SubAdmin from "./screens/CompanyScreens/Profile/SubAdmin";
import Users from "./screens/CompanyScreens/Profile/Users";
import DeviceCompanyList from "./screens/CompanyScreens/DeviceList/DeviceCompanyList";
import Location from "./screens/CompanyScreens/Location/Location";
import CompanyMembersList from "./screens/CompanyScreens/DeviceList/CompanyMembersList";
import CompanyReport from "./screens/CompanyScreens/DeviceList/CompanyReport";
import CompanyNotificationReport from "./screens/CompanyScreens/DeviceList/CompanyNotificationReport";
import AddCompanyRoles from "./screens/CompanyScreens/CompanyRoles/AddCompanyRoles";
import DailyLog from "./screens/Company/DailyLog";
import SuperAdminDashboard from "./screens/KnfSuperAdmin/Dashboard/SuperAdminDashboard";
import SuperAdminList from "./screens/KnfSuperAdmin/Admin/SuperAdminList";
import SuperAdminAdd from "./screens/KnfSuperAdmin/Admin/SuperAdminAdd";
import SuperAdminRoles from "./screens/KnfSuperAdmin/Roles/SuperAdminRoles";
import SuperAdminAddRoles from "./screens/KnfSuperAdmin/Roles/SuperAdminAddRoles";
import SuperAdminCompanyRoles from "./screens/KnfSuperAdmin/Roles/SuperAdminCompanyRoles";
import SuperAdminCompanyRolesView from "./screens/KnfSuperAdmin/Roles/SuperAdminCompanyRolesView";
import AdminCompanyList from "./screens/KnfSuperAdmin/Company/AdminCompanyList";
import AdminAddCompany from "./screens/KnfSuperAdmin/Company/AdminAddCompany";
import SitesList from "./screens/KnfSuperAdmin/Sites/SitesList";
import SitesView from "./screens/KnfSuperAdmin/Sites/SitesView";
import AlertMain from "./screens/KnfSuperAdmin/Alert/AlertMain";
import UserReport from "./screens/KnfSuperAdmin/Report/UserReport";
import SiteReport from "./screens/KnfSuperAdmin/Report/SiteReport";
import AdminNotifications from "./screens/Notifications/AdminNotifications";
import OverallNotifications from "./screens/Notifications/OverallNotifications";
import AddCompany from "./screens/KnfSuperAdmin/Company/AddCompany";
import ViewNotificationDetails from "./screens/Notifications/ViewNotificationDetails";
import AdminSlotMain from "./screens/KnfSuperAdmin/Slot/AdminSlotMain";
import AdminAlertTypes from "./screens/KnfSuperAdmin/Alert/AdminAlertTypes";
import AdminCameras from "./screens/KnfSuperAdmin/Camera/AdminCameras";
import CompanyDashboard from "./screens/CompanySection/Dashboard/CompanyDashboard";
import CompanyAdmin from "./screens/CompanySection/Admin/CompanyAdmin";
import CompanyAddAdmin from "./screens/CompanySection/Admin/CompanyAddAdmin";
import RolesCompany from "./screens/CompanySection/Roles/RolesCompany";
import CompanyAddRoles from "./screens/CompanySection/Roles/CompanyAddRoles";
import UserRoles from "./screens/CompanySection/Roles/UserRoles";
import AddUserRoles from "./screens/CompanySection/Roles/AddUserRoles";
import CompanySites from "./screens/CompanySection/Sites/CompanySites";
import CompanySitesView from "./screens/CompanySection/Sites/CompanySitesView";
import CompanyUserReport from "./screens/CompanySection/Report/CompanyUserReport";
import CompanyIndNotifications from "./screens/CompanySection/Notifications/CompanyIndNotifications";
import CompanySiteReport from "./screens/CompanySection/Report/CompanySiteReport";
import CompanyAlertMain from "./screens/CompanySection/CompanyAlertTypes/CompanyAlertMain";
import CompanyNotifications from "./screens/CompanySection/CompanyNotifications/CompanyNotifications";
import CompanyAdminAlertTypes from "./screens/CompanySection/AlertTypes/CompanyAdminAlertTypes";
import CameraCompanyAdmin from "./screens/CompanySection/Camera/CameraCompanyAdmin";
import CompanySlotMain from "./screens/CompanySection/CompanySlot/CompanySlotMain";
import SiteLayout from "./components/Layouts/SiteLayout";
import SiteDashboard from "./screens/SiteAdmin/Dashboard/SiteDashboard";
import SiteProfile from "./screens/SiteAdmin/Profile/SiteProfile";
import SiteViewProfile from "./screens/SiteAdmin/Profile/SiteViewProfile";
import SiteUserRoles from "./screens/SiteAdmin/SiteUserRoles/SiteUserRoles";
import SiteUserAddRoles from "./screens/SiteAdmin/SiteUserRoles/SiteUserAddRoles";
import SiteUser from "./screens/SiteAdmin/Site User/SiteUser";
import SiteAlertMain from "./screens/SiteAdmin/SiteAlertTypes copy/SiteAlertMain";
import SlotMain from "./screens/SiteAdmin/Slot/SlotMain";
import SiteCamera from "./screens/SiteAdmin/Camera/SiteCamera";
import SiteAdminReport from "./screens/SiteAdmin/Report/SiteAdminReport";
import SiteUserReport from "./screens/SiteAdmin/Report/SiteUserReport";
import SiteNotification from "./screens/SiteAdmin/OverallNotification/SiteNotification";
import GroupDashboard from "./screens/GroupUsers/GroupDashboard/GroupDashboard";
import NewAlerts from "./screens/GroupUsers/NewAlerts/NewAlerts";
import AllocatedAlerts from "./screens/GroupUsers/AllocatedAlerts/AllocatedAlerts";
import OverallAlertdetails from "./screens/GroupUsers/AlertDetails.jsx/OverallAlertdetails";
import ClosedAlerts from "./screens/GroupUsers/ClosedAlerts/ClosedAlerts";
import GroupAlertTypes from "./screens/GroupUsers/AlertTypes/GroupAlertTypes";
import GroupCamera from "./screens/CompanySection/Camera/GroupCamera";
import GroupEscalationTime from "./screens/GroupUsers/GroupEscalations/GroupEscalationTime";
import GroupAlertDays from "./screens/GroupUsers/AlertDays/GroupAlertDays";
import HttpClient from "./Services/HttpClient";
import PrivateRouter from "./components/Layouts/PrivateRouter";
import KnfCompanyAdminList from "./screens/knfCompany/KnfCompanyAdminList";
import GroupProfile from "./screens/GroupUsers/GroupDashboard/GroupProfile";
import ViewNotificationDetailsCom from "./screens/SiteAdmin/OverallNotification/ViewNotificationDetailsCom";

const ReactRoutes = () => {
  let token = localStorage.getItem("token");

  if (token) {
    HttpClient.defaults.headers.common["Authorization"] =
      `Bearer ${token}` || "";
  }

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/registration" element={<Registration />} />
      <Route path="/reset-password/:token" element={<ResetPassword />} />
      <Route element={<PrivateRouter />}>
        <Route element={<Layout />}>
          <Route path="/admin-list" element={<UserList />} />
          <Route
            path="/knf-company-admin-list"
            element={<KnfCompanyAdminList />}
          />
          <Route path="/role" element={<Role />} />
          <Route path="/add-role" element={<AddRole />} />
          <Route path="/user-list" element={<UsersList />} />
          <Route path="/members-list" element={<MembersList />} />
          <Route path="/device-list" element={<DeviceList />} />
          <Route path="/device-add" element={<DeviceAdd />} />
          <Route path="/report" element={<Report />} />
          <Route path="/notificationreport" element={<NotificationReport />} />
          <Route path="/location-marks" element={<LocationMarks />} />
          <Route path="/log-file" element={<Logfile />} />
          <Route path="/daily-log" element={<DailyLog />} />
          <Route path="/company" element={<Company />} />
          <Route path="/company-role" element={<CompanyRole />} />
          <Route path="/company-role-add" element={<CompanyRoleAdd />} />
          {/* WEATHER COMPANY START */}
          <Route path="/:company/manager" element={<Manager />} />
          <Route path="/:company/role" element={<CompanyRoles />} />
          <Route
            path="/:company/add-company-role"
            element={<AddCompanyRoles />}
          />
          <Route path="/:company/sub-admin" element={<SubAdmin />} />
          <Route path="/:company/users" element={<Users />} />
          <Route path="/:company/device-list" element={<DeviceCompanyList />} />
          <Route
            path="/:company/members-list"
            element={<CompanyMembersList />}
          />
          <Route path="/:company/report-list" element={<CompanyReport />} />
          <Route
            path="/:company/notification-report-list"
            element={<CompanyNotificationReport />}
          />
          <Route path="/:company/location-marks" element={<Location />} />
          <Route path="/:company/daily-log" element={<DailyLog />} />
          {/* WEATHER COMPANY END */}
          {/* KNF SECURITY CAMERA SUPER ADMIN ROUTES */}
          <Route
            path="/admin-dashboard"
            index
            element={<SuperAdminDashboard />}
          />
          <Route path="/super-admin-list" index element={<SuperAdminList />} />
          <Route path="/super-admin-add" index element={<SuperAdminAdd />} />
          <Route
            path="/super-admin-roles"
            index
            element={<SuperAdminRoles />}
          />
          <Route
            path="/super-admin-roles-add"
            index
            element={<SuperAdminAddRoles />}
          />
          <Route
            path="/superadmin-company-roles"
            index
            element={<SuperAdminCompanyRoles />}
          />
          <Route
            path="/superadmin-company-roles-view"
            index
            element={<SuperAdminCompanyRolesView />}
          />
          <Route
            path="/admin-company-list"
            index
            element={<AdminCompanyList />}
          />
          <Route
            path="/admin-add-company"
            index
            element={<AdminAddCompany />}
          />
          <Route path="/sites-list" index element={<SitesList />} />
          <Route path="/sites-view" index element={<SitesView />} />
          <Route path="/alert-types" index element={<AlertMain />} />
          <Route path="/user-report" index element={<UserReport />} />
          <Route path="/site-report" index element={<SiteReport />} />
          <Route
            path="/admin-notifications"
            index
            element={<AdminNotifications />}
          />
          <Route
            path="/Overall-notifications"
            index
            element={<OverallNotifications />}
          />
          <Route path="/add-company" index element={<AddCompany />} />
          <Route
            path="/view-notification-details"
            index
            element={<ViewNotificationDetails />}
          />
          <Route
            path="/view-notification-com-details"
            index
            element={<ViewNotificationDetailsCom />}
          />
          <Route path="/admin-slot-main" index element={<AdminSlotMain />} />
          <Route
            path="/admin-alert-types"
            index
            element={<AdminAlertTypes />}
          />
          <Route path="/admin-cameras" index element={<AdminCameras />} />
          {/* COMPANY SECTION */}
          <Route
            path="/company-dashboard"
            index
            element={<CompanyDashboard />}
          />
          <Route path="/company-admin" index element={<CompanyAdmin />} />
          <Route
            path="/company-add-admin"
            index
            element={<CompanyAddAdmin />}
          />
          <Route path="/companyRoles" index element={<RolesCompany />} />
          <Route path="/companyAddRoles" index element={<CompanyAddRoles />} />
          <Route path="/companyUserRoles" index element={<UserRoles />} />
          <Route path="/companyUserAddRoles" index element={<AddUserRoles />} />
          <Route path="/company-sites" index element={<CompanySites />} />
          <Route
            path="/company-sites-view"
            index
            element={<CompanySitesView />}
          />
          <Route
            path="/company-user-report"
            index
            element={<CompanyUserReport />}
          />
          <Route
            path="/company-ind"
            index
            element={<CompanyIndNotifications />}
          />
          <Route
            path="/company-site-report"
            index
            element={<CompanySiteReport />}
          />
          <Route
            path="/company-alert-types"
            index
            element={<CompanyAlertMain />}
          />
          <Route
            path="/company-notifications"
            index
            element={<CompanyNotifications />}
          />
          <Route
            path="/company-admin-alert-types"
            index
            element={<CompanyAdminAlertTypes />}
          />
          <Route
            path="/company-admin-camera"
            index
            element={<CameraCompanyAdmin />}
          />
          <Route path="/company-slot" index element={<CompanySlotMain />} />
          {/* SITE ADMIN SECTION START */}
          <Route path="/site-Dashboard" index element={<SiteDashboard />} />
          <Route path="/site-profile" index element={<SiteProfile />} />
          <Route
            path="/site-view-profile"
            index
            element={<SiteViewProfile siteType={"show"} />}
          />
          <Route path="/site-user-roles" index element={<SiteUserRoles />} />
          <Route
            path="/site-user-add-roles"
            index
            element={<SiteUserAddRoles />}
          />
          <Route path="/site-user" index element={<SiteUser />} />
          <Route path="/site-alert-types" index element={<SiteAlertMain />} />
          <Route path="/site-slot" index element={<SlotMain />} />
          <Route path="/site-camera" index element={<SiteCamera />} />
          <Route
            path="/site-admin-report"
            index
            element={<SiteAdminReport />}
          />
          <Route
            path="/site-admin-user-report"
            index
            element={<SiteUserReport />}
          />
          <Route
            path="/site-notifications"
            index
            element={<SiteNotification />}
          />
          {/* SITE ADMIN SECTION END */}
          {/* GROUP SECTION START */}
          <Route path="/group-dashboard" element={<GroupDashboard />} />
          <Route path="/group-new" element={<NewAlerts />} />
          <Route path="/group-allcoted" element={<AllocatedAlerts />} />
          <Route path="/group-alertdetails" element={<OverallAlertdetails />} />
          <Route
            path="/group-assign-alertdetails"
            element={<OverallAlertdetails />}
          />
          <Route
            path="/group-close-alertdetails"
            element={<OverallAlertdetails />}
          />
          <Route path="/group-closed" element={<ClosedAlerts />} />
          <Route path="/group-alerts" element={<GroupAlertTypes />} />
          <Route path="/group-camera" element={<GroupCamera />} />
          <Route path="/group-escalations" element={<GroupEscalationTime />} />
          <Route path="/group-alertdays" element={<GroupAlertDays />} />{" "}
          <Route path="/group-view-profile" index element={<GroupProfile />} />
          {/* GROUP SECTION END */}
        </Route>
        {/* <Route element={<LayoutCompany />}>
          <Route path="/:company/manager" element={<Manager />} />
          <Route path="/:company/role" element={<CompanyRoles />} />
          <Route
            path="/:company/add-company-role"
            element={<AddCompanyRoles />}
          />
          <Route path="/:company/sub-admin" element={<SubAdmin />} />
          <Route path="/:company/users" element={<Users />} />
          <Route path="/:company/device-list" element={<DeviceCompanyList />} />
          <Route
            path="/:company/members-list"
            element={<CompanyMembersList />}
          />
          <Route path="/:company/report-list" element={<CompanyReport />} />
          <Route
            path="/:company/notification-report-list"
            element={<CompanyNotificationReport />}
          />
          <Route path="/:company/location-marks" element={<Location />} />
          <Route path="/:company/daily-log" element={<DailyLog />} />
        </Route> */}
      </Route>
    </Routes>
  );
};

export default ReactRoutes;
